import { env } from "../env";

const baseUrl = env.REACT_APP_API_URL;

enum Module {
    AUTH = "authentication",
    CUSTOMERS = "customers",
    ORDERS = "orders",
    USERS = "users",
}

const ServicePaths = {
    LOGIN: `${baseUrl}${Module.AUTH}/login`,
    LOGOUT: `${baseUrl}${Module.AUTH}/logout`,
    ACTIVATE_ACCOUNT: `${baseUrl}${Module.AUTH}/activate-account`,
    RECOVER_PASSWORD: `${baseUrl}${Module.AUTH}/recover-password`,
    UPDATE_PASSWORD: `${baseUrl}${Module.USERS}/profile-password`,
    ORDER_OPTIONS: `${baseUrl}${Module.CUSTOMERS}/menu-options`,
    CREATE_ORDER: `${baseUrl}${Module.CUSTOMERS}/orders`,
    HISTORY: `${baseUrl}${Module.CUSTOMERS}/history`,
    MY: `${baseUrl}${Module.CUSTOMERS}/my`,
    ORDERS: `${baseUrl}${Module.ORDERS}`,
    CANCEL_ORDER: (id: number) => `${baseUrl}${Module.ORDERS}/cancel/${id}`,
};

export default ServicePaths;
